import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = ["data-id"];
var _hoisted_2 = ["src"];
var _hoisted_3 = {
  class: "tool-name"
};
import { onMounted } from 'vue';
export default {
  __name: 'eInteract',
  props: {
    elementContent: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // element: {
    //   type: Object,
    //   default: () => ({}),
    // },
    edit: {
      type: Boolean,
      default: true
    }
  },
  emits: ['loaded'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    onMounted(function () {
      emit('loaded', 'eInteract');
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        class: "custom-component tool-content",
        "data-id": "".concat(__props.elementContent.interactiveTools.id, "-").concat(__props.elementContent.interactiveTools.type)
      }, [_createElementVNode("img", {
        src: "".concat(__props.elementContent.content, "?r=").concat(Math.random()),
        crossorigin: "anonymous",
        draggable: "false"
      }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, _toDisplayString(__props.elementContent.interactiveTools.name || '互动工具'), 1), _cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "tool-mask"
      }, [_createElementVNode("span", null, "进入互动工具")], -1))], 8, _hoisted_1);
    };
  }
};